import Footer from 'comps/Footer';

export default Footer;
